module.exports = __webpack_public_path__ + "static/mobilny-crm-a625d90450c7622c0b83b5c0c926b01b.png";